export enum AvatarSource {
  CUSTOM = 'custom',
  INITIALS = 'initials',
  VALUE = 'value'
}
